export default "<div class=\"content-body\">\n  <div class=\"panel-page-body\">\n    <ng-content select=\"[body]\"></ng-content>\n  </div>\n</div>"